import { WEATHER_MAP_LAYOUT_ORIENTATIONS } from '../../../config/weatherMapLayout.config';
import { createWeatherMapPollingQueryOptions } from '../../../utils/weatherMapQuery.utils';

export const SEVERE_WEATHER_ALERTS_ROUTE = 'getAllActiveAlerts';

export const SEVERE_WEATHER_ALERTS_REFRESH_INTERVAL_MINUTES = 3;

export const SEVERE_WEATHER_ALERTS_QUERY_OPTIONS = createWeatherMapPollingQueryOptions({
  refreshIntervalMinutes: SEVERE_WEATHER_ALERTS_REFRESH_INTERVAL_MINUTES,
});

export const SEVERE_WEATHER_ALERTS_DEFAULT_CENTER = Object.freeze([39.8283, -98.5795]);

export const SEVERE_WEATHER_ALERTS_DEFAULT_ZOOM = 5;

export const SEVERE_WEATHER_ALERT_POLYGON_PROVIDERS = Object.freeze(['fusion']);

export const SEVERE_WEATHER_ALERT_PATH_OPTIONS = Object.freeze({
  color: '#ffffff',
  fillOpacity: 0.45,
  weight: 1,
});

export const SEVERE_WEATHER_SELECTED_ALERT_PATH_OPTIONS = Object.freeze({
  ...SEVERE_WEATHER_ALERT_PATH_OPTIONS,
  fillOpacity: 0.65,
  weight: 3,
});

export const SEVERE_WEATHER_ALERTS_PAGE_LAYOUT = Object.freeze({
  resizableOrientation: WEATHER_MAP_LAYOUT_ORIENTATIONS.vertical,
  nonResizableOrientation: WEATHER_MAP_LAYOUT_ORIENTATIONS.vertical,
  mapDefaultSize: '55%',
  panelDefaultSize: '45%',
  mapMinSize: '35%',
  panelMinSize: '30%',
});
